Librarian.Cart.List = new Class({
    Binds: ["addItem"],
    // The items stored in this list
    items: null,

    /*
     * Creates a new empty List instance
     */
    initialize: function() {
        this.items = [];
    },

    /*
     * Destroys every item stored in the current list and resets it to empty
     */
    clear: function() {
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].destroy();
            this.items[i] = null;
        }

        this.items.length = 0;
    },

    //#region Get Methods

    /*
     * Gets the count of the items in this list which match the given options
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     * addType - The type of item to count - Optional, If specified this will force all items in the list into the specified type before counting. If not specified, items will be counted as they were added to the list
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getSize: function(includeDeleted, addType, includeDuplicates) {
        // If we aren't told whether to include deleted items, assume we should
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = true;

        return this.getItems(includeDeleted, addType, includeDuplicates).length;
    },

    /*
     * Gets the items in this list that match the given options
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     * addType - The type of item to include - Optional, If specified this will force all items in the list into the specified type. If not specified, items will be added as they were added to the list
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getItems: function(includeDeleted, addType, includeDuplicates) {
        // If we aren't told whether to include deleted items, assume we shouldn't
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;
        // If we aren't told whether to include duplicated items, assume we shouldn't
        if ((typeof includeDuplicates == "undefined") || (includeDuplicates == null))
            includeDuplicates = true;

        // If we are included deleted items and aren't looking for a specific type
        // of item, it's just as simple as returning every item
        if (includeDeleted && ((typeof addType == "undefined") || (addType == null))) {
            // If we include duplicates, it's literally just this list
            if (Librarian.cart.allowDuplicates || includeDuplicates)
                return this.items;
            // Otherwise filter out the duplicates
            else {
                return this.items.filter(function(item) {
                    return !item.duplicate;
                });
            }
        }

        var items = [],
            // Use custom contains and indexOf methods so we can use our item's `equals` method
            contains = function(item, ignoreGroup) {
                return items.some(function(currentItem) {
                    return item.equals(currentItem, ignoreGroup);
                });
            },
            indexOf = function(item) {
                for (var j = 0; j < items.length; j++) {
                    if (item.equals(items[j]))
                        return j;
                }

                return -1;
            };

        // Otherwise, we have to iterate through each item
        for (var i = 0; i < this.items.length; i++) {
            // Skip the duplicate ones and deleted ones (only if we're told not to include them)
            if ((!includeDeleted && this.items[i].deleted) || (!includeDuplicates && this.items[i].duplicate))
                continue;

            // If this is a file inside a group, don't add it to the parent group if there is one
            // Fixes a case creating a package from two files in a group would only add the first file to the list
            var ignoreGroup = ((this.items[i].groupid > 0) || (this.items[i].presid > 0)) && (this.items[i].slideid <= 0) && (this.items[i].fileid > 0);

            // If this was added as a file and we want to see slides,
            // add all of its slides as items in the items array
            if ((addType == Librarian.Cart.addTypes.SLIDE) && (this.items[i].addType == Librarian.Cart.addTypes.FILE)) {
                // Add each of this item's children, if there are any
                if (this.items[i].items) {
                    var childItems = this.items[i].items.getItems(includeDeleted, null, includeDuplicates);
                    // Treat SlideShows and locked files differently because they don't have any items
                    if ((childItems.length == 0) && (this.items[i].isslideshow || ((this.items[i].flags & Librarian.fileFlags.passwordProtected) == Librarian.fileFlags.passwordProtected)) && !contains(this.items[i], ignoreGroup))
                        items.push(this.items[i]);
                    else
                        items.append(childItems);
                }
                // Otherwise just add this (if it's not there already)
                else if (!contains(this.items[i], ignoreGroup))
                    items.push(this.items[i]);
            }
            // If this was added as a slide and we want to see files
            else if ((addType == Librarian.Cart.addTypes.FILE) && (this.items[i].addType == Librarian.Cart.addTypes.SLIDE)) {
                // Make this item's parent
                var parentFile = Librarian.Cart.Item.makeParent(this.items[i]);

                // If we don't already have this item in the files list, add it
                if (!contains(parentFile)) {
                    parentFile.addItem(this.items[i]);
                    items.push(parentFile);
                }
                else {
                    var parentIndex = indexOf(parentFile);
                    items[parentIndex].addItem(this.items[i]);
                }
            }
            // Otherwise just add this item straight, if we don't already have it
            else if (!contains(this.items[i], ignoreGroup))
                items.push(this.items[i]);
        }

        return items;
    },

    /*
     * Gets the specified item or its parent, whichever exists in the list
     *
     * data - The data for which to get the representative cart item or its parent
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    getParentOrItemItself: function(data, ignoreGroup) {
        // If we aren't told to ignore groups, assume not.
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null))
            ignoreGroup = false;
        // Create an item out of the data given
        var item = new Librarian.Cart.Item(data),
            // Check if this item is in the list
            itemIndex = this.indexOf(item, true, ignoreGroup);

        item.destroy();
        item = null;

        // If it is, return that item.
        if (itemIndex >= 0)
            return this.items[itemIndex];

        // Otherwise, change this item into a probable parent
        item = Librarian.Cart.Item.makeParent(data);

        // If this list doesn't contain the parent, return null
        var parentIndex = this.indexOf(item, true, ignoreGroup);

        // Destroy the created parent item
        item.destroy();
        item = null;

        if (parentIndex < 0)
            return null;

        // Otherwise return the parent itself
        return this.items[parentIndex];
    },

    /*
     * Gets the data stored at the given index within the list
     *
     * index - The location from which to get data
     */
    getItem: function(index) {
        return this.items[index];
    },

    //#endregion

    //#region Set Methods

    /*
     * Sets the item in this list at the given index to the given value
     *
     * index - The location to insert the given value at
     * value - The data to insert into the list
     */
    setItem: function(index, value) {
        // Only set the item if the given index is valid.
        if (!value || (index < 0) || (index >= this.items.length))
            return;

        this.items[index] = value;
    },

    /*
     * Sets the list item represented by the given data to be deleted
     *
     * data - The data whose list item is being set to be deleted
     */
    setItemDeleted: function(data) {
        if (!data)
            return;

        // Get the parent item if there is one
        var parentItem = this.getParentOrItemItself(data);

        if (parentItem) {
            // If this item is just the data wrapped
            // in an object set it to deleted
            if (parentItem.equals(data))
                parentItem.deleted = true;
            else {
                // Otherwise split this parent item into its slides
                this.splitFileAndAddInPlace(parentItem);
                // Find the slide for this item
                var index = this.indexOf(data);
                // And set it to deleted
                this.items[index].deleted = true;
            }
        }
    },

    //#endregion

    //#region Add/Remove

    /*
     * Adds the given item to this list
     *
     * item - Item to be added to the list
     * undelete - Whether to undelete this item if it already exists in the list - Optional, defaults to true
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     *
     * Returns the item or its parent if it has one
     */
    addItem: function(item, undelete, ignoreGroup) {
        // If we aren't told whether or not to undelete a deleted item, assume we should
        if ((typeof undelete == "undefined") || (undelete == null))
            undelete = true;

        // Try to get the parent, if there is one
        var parentItem = this.getParentOrItemItself(item, ignoreGroup);
        if (parentItem) {
            // If we just got ourselves, check if it is deleted
            if (parentItem.equals(item, ignoreGroup)) {
                // If it is deleted and we're allowed to undelete, do so
                if (parentItem.deleted && undelete)
                    parentItem.deleted = false;

                // Return the parentItem instead of the item because object references
                // matter when expanding the item into it's individual slides
                // If "item" was returned here, the parent in cartItems wouldn't get
                // it's child slides added to it
                return parentItem;
            }
            // The parent handles duplication checks and unsetting
            // the "deleted" flag when adding children
            else
                parentItem.addItem(item);
        }
        // If there's no parent, just add the item straight up
        else
            this.items.push(item);

        // Return the new item
        return item;
    },

    /*
     * Removes the item that represents the given data from this list
     *
     * data - The data whose representative item in this list is going to be removed
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     *
     * Returns true if the removal succeeded, false otherwise
     */
    removeItem: function(data, ignoreGroup) {
        // If we aren't told to ignore groups, assume not
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null))
            ignoreGroup = false;

        // Get the index of the item to remove, even if it's deleted
        var index = this.indexOf(data, true, ignoreGroup);

        // If this item wasn't found and it was a slide
        if ((index < 0) && (data.slidenumber > 0)) {
            // Try to find its file
            index = this.indexOfParent(data, true);
            // If the file was found
            if (index >= 0) {
                var item = this.items[index];
                // Split it into its slides
                this.splitFileAndAddInPlace(item);
                // and find the index of this slide now
                index = this.indexOf(data, true, ignoreGroup);
            }
        }

        return this.removeItemByIndex(index);
    },

    /*
     * Removes the item in this list at the given index
     *
     * Returns true if the removeal succeeded, false otherwise
     */
    removeItemByIndex: function(index) {
        // If the item exists, cut it out and return true
        if (index >= 0) {
            this.items.splice(index, 1);
            return true;
        }

        // Otherwise return false to show we didn't remove anything
        return false;
    },

    /*
     * Removes every item in this list who is a child of the given `parentItem`
     *
     * parentItem - The parent item whose children are to be removed from this list
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    removeItemChildren: function(parentItem, ignoreGroup) {
        // If we aren't told to ignore groups, assume not
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null))
            ignoreGroup = false;
        // If the parent isn't actually a parent, this can't be its child
        if ((parentItem.slidenumber > 0) || (parentItem.itemnumber > 0))
            return;

        // For every item in this list
        for (var i = 0, length = this.getSize(); i < length; i++) {
            // Check if it is a child of the given parent and remove it
            if (this.items[i].isChildOf(parentItem, ignoreGroup)) {
                // If it removes, decrement the counter so that
                // when it is incremented we don't skip an item
                if (this.removeItemByIndex(i)) {
                    i--;
                    length--;
                }
            }
        }
    },

    //#endregion

    //#region Array Overrides and Expansions

    //#region Index Of

    /*
     * Finds the index of the item in this list which represents the given data
     *
     * data - Data whose representative list item is being found
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     *
     * Returns the index of the item or -1 if it is not in this list
     */
    indexOf: function(data, includeDeleted, ignoreGroup, includeSubItems) {
        // If we aren't told to ignore groups, assume not
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null))
            ignoreGroup = false;
        // If we aren't told whether or not to find deleted files, assume not
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;

        var item;
        // For every item in this list
        if (includeSubItems) {
            for (var i = 0, length = this.getSize(); i < length; i++) {
                item = this.items[i];
                if (item.items && item.items.items && item.items.items.length > 0) {
                    for (var j = 0, subLength = item.items.getSize(); j < subLength; j++) {
                        var subItem = item.items.items[j];
                        // Skip it if it is deleted and we don't want deleted items
                        if (!includeDeleted && item.deleted)
                            continue;

                        // Otherwise check if it the item we're looking for
                        if (subItem.equals(data, ignoreGroup))
                            return j;
                    }
                } else {
                    // Skip it if it is deleted and we don't want deleted items
                    if (!includeDeleted && item.deleted)
                        continue;

                    // Otherwise check if it the item we're looking for
                    if (item.equals(data, ignoreGroup))
                        return i;
                }
            }
        } 
        else {
            for (var i = 0, length = this.getSize(); i < length; i++) {
                item = this.items[i];

                // Skip it if it is deleted and we don't want deleted items
                if (!includeDeleted && item.deleted)
                    continue;

                // Otherwise check if it the item we're looking for
                if (item.equals(data, ignoreGroup))
                    return i;
            }
        }

        // If we didn't find the right item, return -1 as a default
        return -1;
    },

    /*
     * Finds the index of the item in this list which represents the given parent of the data
     *
     * childItem - Item for which the parent list item is being found
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    indexOfParent: function(childItem, includeDeleted) {
        // If we aren't told whether or not to find deleted files, assume not.
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;

        var item;
        // Find the index of the first non-deleted parent of the given child.
        for (var i = 0, length = this.getSize() ; i < length; i++) {
            item = this.items[i];

            // Skip it if it is deleted and we don't want deleted items.
            if (!includeDeleted && item.deleted)
                continue;

            // Otherwise check if this is the parent of the item we're looking for
            if (item.isParentOf(childItem))
                return i;
        }

        // If this list doesn't have any parents for that child, return -1
        return -1;
    },

    /*
     * Finds the index of the last item in this list which is a child of the given `parentItem`
     *
     * parentItem - Item for which the last child list item is being found
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    lastIndexOfChild: function(parentItem, includeDeleted) {
        // If we aren't told whether or not to find deleted files, assume not.
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;

        var item;
        // Find the index of the last non-deleted child of the given parent.
        for (var i = this.getSize() - 1; i >= 0; i--) {
            item = this.items[i];

            if (!includeDeleted && item.deleted)
                continue;

            if (item.isChildOf(parentItem))
                return i;
        }

        // If this list doesn't have any children of that parent, return -1
        return -1;
    },

    /*
     * Finds the index of the first item in this list which is a child of the given `parentItem`
     *
     * parentItem - Item for which the first child list item is being found
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    firstIndexOfChild: function(parentItem, includeDeleted) {
        // If we aren't told whether or not to find deleted files, assume not.
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;

        var item;
        // Find the index of the first non-deleted child of the given parent.
        for (var i = 0, length = this.getSize() ; i < length; i++) {
            item = this.items[i];

            if (!includeDeleted && item.deleted)
                continue;

            if (item.isChildOf(parentItem))
                return i;
        }

        // If this list doesn't have any children of that parent, return -1
        return -1;
    },

    //#endregion

    //#region Contains

    /*
     * Determines whether the given data exists in the list and is marked for deletion
     *
     * data - Data to find the representative list item of
     *
     * Returns true if the item is found and is marked for deletion, false otherwise
     */
    containsDeleted: function(data) {
        var item;
        // For every item in this list
        for (var i = 0, length = this.getSize(); i < length; i++) {
            item = this.items[i];

            // Skip it if it isn't deleted
            if (!item.deleted)
                continue;

            // Otherwise check if it the item we're looking for.
            if (item.equals(data))
                return true;
        }

        // If we didn't find the right item, return false
        return false;
    },

    /*
     * Determines whether the given data exists in the list and matches the given options
     *
     * data - Data to find the representative list item of
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to false
     */
    contains: function (data, includeDeleted, ignoreGroup, includeDuplicates) {
        // If we aren't told whether to include duplicated items, assume we shouldn't
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;
        // If we aren't told whether to include duplicated items, assume we shouldn't
        if ((typeof includeDuplicates == "undefined") || (includeDuplicates == null))
            includeDuplicates = false;

        var dataItem = new Librarian.Cart.Item(data);

        // Returns true if at least 1 of the items in this list is equal
        // and it is either not deleted, or deleted items are allowed.
        return this.items.some(function(item) {
            var flag = true;

            // If this item is deleted, check whether we allow that or not.
            if (item.deleted)
                flag = (item.deleted === includeDeleted);
            if (!includeDuplicates && item.duplicate)
                flag = false;

            // The deleted status needs to be allowed AND the items
            // need to match for this to be true.
            //return flag && dataItem.equals(item, ignoreGroup) || (item.contentId == dataItem.contentId && item.contentType == dataItem.contentType);
            return flag && dataItem.equals(item, ignoreGroup);
        });
    },

    //#endregion

    /*
     * Adds the given item to the end of the list
     *
     * item - The item to be added to the list
     */
    push: function(item) {
        return this.items.push(item);
    },

    /*
     * Determines whether any of the items in the list matches the given predicate function
     *
     * func - Boolean function which checks whether the given item matches a set of search criteria
     */
    some: function(func) {
        return this.items.some(func);
    },

    /*
     * Filters the list of items to only contain items that match the given predicate function
     *
     * func - Boolean function which checks whether the given item matches a set of search criteria
     */
    filter: function(func) {
        return this.items.filter(func);
    },

    //#endregion

    //#region Helper Methods

    /*
     * Determines whether this list has any deleted items
     */
    hasDeleted: function() {
        var item;
        // For every item in this list
        for (var i = 0, length = this.getSize(); i < length; i++) {
            item = this.items[i];

            // Skip it if it isn't deleted
            if (!item.deleted)
                continue;

            // If we ever get here, we have a deleted item
            return true;
        }

        // If we ever get here, we don't have a deleted item
        return false;
    },

    /*
     * Splits the given file item into its contained slide items which are then inserted at the same location the file once occupied
     *
     * data - File item to be split into slides
     */
    splitFileAndAddInPlace: function(data) {
        // Only files are splitable
        if (data.addType != Librarian.Cart.addTypes.FILE)
            return;

        var index = this.indexOf(data, true),
            item = this.items[index],
            items = [];
        // Get each child of this item
        for (var i = 0, length = item.getSize(); i < length; i++) {
            var slide = item.getItem(i);

            // If this is a group, set the item number
            if ((slide.groupid > 0) || (slide.presid > 0))
                slide.itemnumber = (i + 1);
            // Otherwise, set the slide number
            else if (slide.fileid > 0)
                slide.slidenumber = (i + 1);

            // Change it to a Slide
            slide.addType = Librarian.Cart.addTypes.SLIDE;
            // Save its extra fields
            slide.parentfields = item.extrafields;
            // And save it
            items.push(slide);
        }

        // Remove the item at this index and add all the split items we just created
        this.removeItemByIndex(index);
        this.insertItemsAt(items, index);
    },

    /*
     * Moves an item in the list in front of a second item
     *
     * firstItem - The item to be moved
     * secondItem - The item in front of which the first item will be moved
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item - Optional, defaults to false
     */
    moveItem: function(firstItem, secondItem, ignoreGroup) {
        // If the cart isn't valid, somehow, we can't continue past this point
        if (!Librarian.userCart)
            return;

        var fromParent = false, toParent = false;
        // Get the indeces for the given items
        if (Librarian.userCart.isInSlideView()) {
            // If this was added as a file
            if (firstItem.addType == Librarian.Cart.addTypes.FILE) {
                // And we're not dropping it on the first slide,
                // split it into its individual slides
                if (firstItem.slidenumber > 1)
                    this.splitFileAndAddInPlace(Librarian.Cart.Item.makeParent(firstItem));
                // Otherwise, remember to get the parent index instead
                else
                    fromParent = true;
            }

            // If this was added as a file
            if (secondItem.addType == Librarian.Cart.addTypes.FILE) {
                // And we're not dropping it on the first slide,
                // split it into its individual slides
                if (secondItem.slidenumber > 1)
                    this.splitFileAndAddInPlace(Librarian.Cart.Item.makeParent(secondItem));
                // Otherwise, remember to get the parent index instead
                else
                    toParent = true;
            }
        }

        var from;
        // Get the index of the parent, if we're told to
        if (fromParent)
            from = this.indexOfParent(firstItem, true);
        // Otherwise just get the index of this item
        else
            from = this.indexOf(firstItem, true, ignoreGroup);

        var to;
        // Get the index of the parent, if we're told to
        if (toParent)
            to = this.indexOfParent(secondItem, true);
        // Otherwise just get the index of this item
        else
            to = this.indexOf(secondItem, true, ignoreGroup);

        var size = this.getSize();
        // If the "to" index is invalid, don't continue
        if ((to < 0) || (to >= size))
            return;

        // If the "from" index is invalid, don't continue
        if ((from < 0) || (from >= size))
            return;

        // If the indeces are the same, don't continue
        if (from == to)
            return;

        // Store the current item
        var item = this.items[from];

        // Move this item to the same section
        item.section = this.items[to].section;

        // Move all the other items to the correct place
        if (from < to) {
            for (var i = from; i < to; i++)
                this.setItem(i, this.items[i + 1]);
        }
        else {
            for (var i = from; i > to; i--)
                this.setItem(i, this.items[i - 1]);
        }

        // Set the item to its new location
        this.setItem(to, item);

        // If we rearranged stuff, close the download window because it will need to reprocess the data
        if (Librarian.userCart.downloadWindow) {
            Librarian.userCart.downloadWindow.close();
            Librarian.userCart.downloadWindow = null;
        }
    },

    /*
     * Inserts the given item at the location specified by `index`
     *
     * item - List item to be inserted
     * index - Location within the list to which the item will be inserted
     */
    insertItemAt: function(item, index) {
        this.items.splice(index, 0, item);
    },

    /*
     * Inserts the given list of items at the location specified by `index`
     *
     * item - List of list items to be inserted
     * index - Location within the list to which the items will be inserted
     */
    insertItemsAt: function(items, index) {
        // Add each item, 1-by-1, in order, to the given location
        for (var i = 0, length = items.length; i < length; i++)
            this.insertItemAt(items[i], index + i);
    },

    /*
     * Updates the duplicate state of each item in this list
     */
    updateDuplicateState: function() {
        // If the cart isn't valid, somehow, we can't continue past this point
        if (!Librarian.userCart)
            return;

        // Go through each item
        for (var i = 0, length = this.items.length; i < length; i++) {
            // If it's duplicate, but it's not marked as in the cart anymore, remove the duplicate flag
            if (this.items[i].duplicate && !Librarian.userCart.isInCart(this.items[i], true, false))
                this.items[i].duplicate = false;
            this.items[i].updateDuplicateState();
        }
    }

    //#endregion
});